import handlers from './handlers';

const init = () => {
  handlers.onBeforeSynchronizeElement();
  handlers.onBeforeSetElementAttribute();
  handlers.onBeforeReplaceElement();
};

export default init;
